import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import { useAuth } from '../hooks/useAuth'

type Mode = 'loading' | 'setup' | 'login'

export function LoginPage() {
  const [mode, setMode]               = useState<Mode>('loading')
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('')
  const [token, setToken]             = useState('')
  const [error, setError]             = useState('')
  const [isLoading, setIsLoading]     = useState(false)
  const { login }                     = useAuth()
  const navigate                      = useNavigate()

  useEffect(() => {
    api.auth.status()
      .then(({ setup }) => {
        if (setup) {
          setMode('login')
        } else {
          api.auth.setup()
            .then(({ qrCodeDataUrl }) => {
              setQrCodeDataUrl(qrCodeDataUrl)
              setMode('setup')
            })
            .catch(() => setMode('login'))
        }
      })
      .catch(() => setMode('login'))
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)
    try {
      let jwt: string
      if (mode === 'setup') {
        const res = await api.auth.verifySetup(token)
        jwt = res.jwt
      } else {
        const res = await api.auth.login(token)
        jwt = res.jwt
      }
      login(jwt)
      navigate('/')
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Invalid code')
    } finally {
      setIsLoading(false)
      setToken('')
    }
  }

  if (mode === 'loading') {
    return (
      <div className="login-page">
        <div className="login-card">
          <p style={{ color: 'var(--text-muted)' }}>Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/whimer-wordmark.svg" alt="Whimer" className="login-logo-wordmark" />
        </div>

        <h1>{mode === 'setup' ? 'First-time Setup' : 'Sign In'}</h1>

        {mode === 'setup' && (
          <div className="login-setup">
            <p className="login-hint">Scan with Google Authenticator, Authy, or any TOTP app</p>
            {qrCodeDataUrl && (
              <img src={qrCodeDataUrl} alt="TOTP QR Code" className="login-qr" />
            )}
            <p className="login-hint small">Then enter the 6-digit code below to activate</p>
          </div>
        )}

        {mode === 'login' && (
          <p className="login-hint">Enter your 6-digit authenticator code</p>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]{6}"
            maxLength={6}
            value={token}
            onChange={e => setToken(e.target.value)}
            placeholder="000000"
            autoFocus
            autoComplete="one-time-code"
            className="login-input"
          />
          {error && <p className="login-error">{error}</p>}
          <button
            type="submit"
            disabled={isLoading || token.length !== 6}
            className="login-btn"
          >
            {isLoading ? '...' : mode === 'setup' ? 'Activate' : 'Sign In'}
          </button>
        </form>

        <button type="button" className="login-alt-link" onClick={() => navigate('/connect')}>
          เปลี่ยนเซิร์ฟเวอร์
        </button>
      </div>
    </div>
  )
}
